import { funcType } from '@lc/types/Misc';

import { Equipment, EquipmentVerbose } from './types';

export function createCardEquipment(
	id: number = -1,
	cost: number = 0,

	title: string = ``,
	description: string = ``,
	flavor: string = ``,

	modifier: string = ``,
	requireTarget: boolean = false,
	requireSource: boolean = false,
	hasDiscardAction: boolean = false,
	hasRepeatableAction: boolean = false
): Equipment {
	const type = 'Equipment';

	return {
		id,
		cost,
		type,

		title,
		description,
		flavor,

		modifier,
		requireTarget,
		requireSource,
		hasDiscardAction,
		hasRepeatableAction,
	};
}

export function createCardEquipmentVerbose(
	equipment: Equipment,
	initAction: funcType,
	discardAction: funcType = () => ({}),
	persistentAction: funcType = () => ({})
): EquipmentVerbose {
	return {
		...equipment,
		initAction,
		discardAction,
		persistentAction,
	};
}
